import { ref, computed } from 'vue'

type GameState = 'waiting' | 'countdown' | 'playing' | 'finished'

const gameState = ref<GameState | null>(null)

export function useGameState() {
  const setGameState = (state: GameState | null) => {
    gameState.value = state
  }

  const isGameActive = computed(() => {
    return gameState.value === 'playing' || gameState.value === 'countdown'
  })

  const isGameFinished = computed(() => {
    return gameState.value === 'finished'
  })

  const isGameWaiting = computed(() => {
    return gameState.value === 'waiting'
  })

  return {
    gameState: computed(() => gameState.value),
    setGameState,
    isGameActive,
    isGameFinished,
    isGameWaiting
  }
}
